import { ReactElement } from 'react';
import { connect } from 'react-redux';
import { getCurrentUserPermissions } from '../../features/user/redux/userSelectors';
import { RootState } from '../../store';
import { ListItemLink } from '../ListItemLink';
import { ResourceType } from '../PricePrgClient';

const mapStateToProps = (state: RootState) => ({
    currentUserPermissions: getCurrentUserPermissions(state)
});

type OwnProps = {
    resource: ResourceType;
    link: string;
    name: string;
    icon: ReactElement;
    tooltip?: string;
};
type Props = ReturnType<typeof mapStateToProps> & OwnProps;
const GuardedListItemLink = ({ currentUserPermissions, resource, link, name, icon, tooltip }: Props) => {
    if (!currentUserPermissions.isAdmin && !currentUserPermissions.accessiblePages.includes(resource)) {
        return null;
    }

    return <ListItemLink to={link} primary={name} icon={icon} tooltip={tooltip} />;
};

export default connect(mapStateToProps)(GuardedListItemLink);
